// extracted by mini-css-extract-plugin
export default {"steps":"styles_steps__SAEkK","stepDescription":"styles_stepDescription__SJJt0","stepCompletion":"styles_stepCompletion__Au1lK"};